import {Component, Input, Output, EventEmitter, OnInit, OnDestroy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PageButtonComponent} from '../buttons/page-button.component';
import {ThemeService} from '../../services/theme-service';
import {ActivatedRoute, Router} from '@angular/router';
import {AppStateService} from '../../services/app-state.service';
import {Subscription} from 'rxjs';
import {BorderIconButtonComponent} from '../buttons/border-icon-button.component';
import {TranslateService} from '../../services/translate.service';
import {BottomSheetService} from '../../services/bottom-sheet.service';
import {LoyaltyConfig, LoyaltyConfigProgram, VenueConfig} from '../../models/FSConfig';
import {ActionButtonComponent} from '../buttons/action-button.component';
import {LoyaltyProgram} from '../../models/loyalty-program';
import {AuthorizedApiService} from '../../services/authorized-api.service';
import {LoadingSpinnerComponent} from './loading-spinner-component';

@Component({
  standalone: true,
  imports: [CommonModule, PageButtonComponent, BorderIconButtonComponent, ActionButtonComponent, LoadingSpinnerComponent],
  selector: 'app-loyalty-menu',
  template: `
    <div *ngIf="isLoggedIn && programs==null">
      <app-loading-spinner></app-loading-spinner>
    </div>
    <div *ngIf="programs && isLoggedIn" class="max-w-lg mx-auto bg-theme-surface-80 pb-safe w-full">
      <div class="flex flex-col py-2" *ngFor="let program of programs">
        <app-border-icon-button icon="fa-crown" [text]="getTitle(program)" (onClick)="displayCard(program)"></app-border-icon-button>
      </div>
      <div *ngFor="let program of signupablePrograms" class="flex flex-col py-2">
        <app-border-icon-button icon="fa-circle-plus" [text]="program.name" (onClick)="becomeMember(program)"></app-border-icon-button>
      </div>
      <div class="flex flex-col pt-2 pb-8">
        <app-border-icon-button icon="fa-square-plus" [text]="translate.getString('Lägg till')" (onClick)="connectCard()"></app-border-icon-button>
      </div>
    </div>
    <div *ngIf="!isLoggedIn" class="mb-4">
      <div class="font-bold text-lg mb-6 text-center">{{translate.getString('Verifiera dig för att skaffa eller hantera lojalitetsprogram')}}</div>
      <app-action-button [text]="translate.getString('Verifiera')" (onClick)="login()"></app-action-button>
    </div>
  `
})
export class LoyaltyMenuComponent implements OnInit, OnDestroy {
  @Output() onClick = new EventEmitter<MouseEvent>();
  private sub?: Subscription;
  isAnon?: boolean;
  isLoggedIn: boolean = false;
  config?: VenueConfig;
  programs?: LoyaltyProgram[];
  hasMemberLoyalty: boolean = false;
  private loyalty?: LoyaltyConfig;
  signupablePrograms: LoyaltyConfigProgram[] = [];

  constructor(private themeService: ThemeService, private router: Router, private route: ActivatedRoute,
              private appStateService: AppStateService, protected translate: TranslateService,
              private sheetService: BottomSheetService, private api: AuthorizedApiService) {}

  ngOnInit(): void {
    this.sub = this.appStateService.observeAppState().subscribe(appState => {
      this.loyalty = appState.cfg?.loyalty;
      this.isAnon = appState.order.user_cfg.is_anon;
      this.isLoggedIn = !appState.order.user_cfg.is_anon;
      this.config = appState.cfg;
      if (this.programs == null && this.isLoggedIn) {
        this.fetchCardData(appState.venueId);
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  login() {
    this.sheetService.displaySignin(1);
  }

  connectCard() {
    this.sheetService.pushSheet({sheetClass: "add-loyalty", title: this.translate.getString("Lägg till befintligt")});
  }

  private fetchCardData(venueId: number) {
    this.api.fetchLoyaltyPrograms(venueId.toString()).subscribe((response) => {
      console.log('Loyalty programs:', response);
      this.programs = response;
      // Find programs that are signupable that are not already connected
      const programsWithSignup = this.loyalty?.programs?.filter(p => p.self_signup) ?? [];
      this.signupablePrograms = programsWithSignup.filter(p => !this.programs?.find(p2 => p2.program_id == p.id));
    });
  }

  displayCard(program: LoyaltyProgram) {
    this.sheetService.pushSheet({sheetClass: "loyalty-card", title: this.translate.getString('Lojalitetsprogram'), sheetData: program});
  }

  getTitle(program: LoyaltyProgram) {
    if(program.points == null) {
      return program.program_name??'';
    }
    return `${program.program_name??''} (${program.points} poäng)`;
  }

  becomeMember(program: LoyaltyConfigProgram) {
    this.sheetService.pushSheet({sheetClass: "signup-loyalty", title: this.translate.getString('Skaffa') + " " + program.name, sheetData: program});
  }
}
